<template>
  <div>
    <div class="wow animate__slideInUp">
      <div class="history about-timeline">
        <div class="wrap wrap2 flex">
          <div class="sidebar">
            <div class="wrap wrap2">
              <div class="about-timeline-year">
                <div id="wrapper">
                  <div
                    class="dd"
                    v-for="(item, idx) in ContentInfos"
                    :key="idx"
                    :class="{ active: idx == 0 }"
                  >
                    <a href="#"> {{ item.Year }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="content year-content">
            <ul>
              <li
                v-for="(item, idx) in ContentInfos"
                :key="idx"
                :class="{ 'li1 active': idx == 0 }"
              >
                <h4>{{ item.Year }}</h4>
                <div class="overtext">
                  <div
                    class="dd"
                    v-for="(item2, idx2) in item.ContentList"
                    :key="idx2"
                  >
                    <div class="tit1">{{ item2.Title }}</div>
                    <div class="tit2">{{ item2.Summary }}</div>
                    <div class="timeLineImg">
                      <el-image
                        class="timeImg"
                        :src="item2.PicUrl"
                        fit="contain"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["ContentInfos"],
  data() {
    return {};
  },

  mounted() {
    // 发展历程
    var $yearContent = $(".year-content");
    var height = $(".li1").outerHeight();
    $(".year-content").height(height);
    console.log(height, "+++++++++1111");
    $(document).on("click", ".about-timeline-year .dd", function (e) {
      e.preventDefault();
      $(".year-content").removeAttr("style");
      $(".year-content .overtext").removeClass("active");
      $(".year-content .btn-loadmore").show();
      $(".year-content .btn-loadmore.active").hide();
      $(this).addClass("active").siblings().removeClass("active");
      $yearContent
        .find("li")
        .eq($(this).index())
        .addClass("active")
        .siblings()
        .removeClass("active");
      var num = 0;
      num = parseInt(
        $yearContent.find("li").eq($(this).index()).position().top,
        10
      );
      var height2 = $(".year-content ul li.active").outerHeight();
      $(".year-content").height(height2);
      console.log(height2, "+++++++++3333");
      var _winw = $(window).width();
      var topH = 90;
      if (_winw >= 1400) {
        topH = 120;
      }
      if (_winw <= 981) {
        topH = 120;
      }
      $yearContent.animate(
        {
          scrollTop: num + $yearContent.scrollTop() - topH,
        },
        400
      );
      $("html,body").animate(
        {
          scrollTop:
            $(".about-timeline").offset().top - $(".el-header").outerHeight(),
        },
        400
      );
    });
  },
};
</script>
<style scoped lang="scss">
.history {
  .wrap {
    padding: 30px 0 0;
    flex-wrap: wrap;
    &::before {
      display: none;
    }
  }
  .wrap2 {
    width: 100%;
    max-width: 100%;
  }
  .sidebar {
    width: 100%;
    overflow: hidden;
    z-index: 1;
    #wrapper {
      flex-wrap: nowrap;
      white-space: nowrap;
      display: flex;
      justify-content: center;
      overflow-x: auto;
      padding-bottom: 25px;
      margin-bottom: 20px;
      position: relative;
      &::before {
        content: "";
        height: 1px;
        width: 100%;
        background: #ddd;
        position: absolute;
        left: 0;
        top: 1px;
      }
    }
    .dd {
      margin: 0 25px;
      margin-bottom: 0;
      padding: 10px 0;
      float: left;
      &::before {
        left: 0;
        top: 0;
        z-index: 2;
        width: 0;
        height: 5px !important;
      }
      &.active {
        &::before {
          width: 100%;
          height: 5px !important;
        }
      }
    }
    .side-wrap {
      max-width: 200px;
      padding-left: 3px;
      margin-left: -4px;
      overflow: hidden;
      .dl {
        margin-right: -10px;
        max-height: 650px;
        overflow-y: auto;
      }
    }
  }
  .about-timeline-year {
    max-height: 600px;
    margin-right: -10px;
    overflow: hidden;
    overflow-y: auto;
  }
  .year-content {
    overflow: hidden;
    height: 1234px;
    ul {
      max-width: 680px;
      margin: 0 auto;
      overflow: hidden;
      padding-right: 0;
      li {
        padding-bottom: 25px;
        opacity: 0.1;
        padding-top: 25px;
        width: auto;
        display: block;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
        width: 100%;
        .overtext {
          line-height: 1.6;
          // height: 500px;
          overflow: hidden;
          position: relative;
          &::before {
            content: "";
            left: 0;
            height: 80px;
            width: 100%;
            position: absolute;
            bottom: 0;
            background: linear-gradient(
              rgba(245, 245, 245, 0) 0%,
              rgba(245, 245, 245, 1) 90%
            );
            z-index: 9;
          }
          .cont2 {
            display: none;
          }
          &.active {
            .cont1 {
              display: none;
            }
            .cont2 {
              display: block;
            }
          }
        }

        .dd {
          margin-bottom: 15px;
        }
        .tit1 {
          padding: 5px 0;
          font-size: 20px;
          font-weight: bold;
        }
        .tit2 {
          padding: 6px 0 20px 0;
        }
        h4 {
          font-size: 45px;
          color: #5a5858;
          margin-bottom: 15px;
          text-align: left;
        }

        &.active {
          opacity: 1;
          .overtext::before {
            display: none;
          }
        }
      }
    }
  }
}

@media (max-width: 1441px) {
  .history {
    padding-bottom: 30px;
    .year-content {
      overflow: hidden;
      height:985px;
    }
  }

  .history .wrap {
    padding-top: 15px;
  }

  .history .year-content ul {
    max-width: 500px;
  }
  .history .year-content ul li {
    padding-top: 15px;
  }
}

@media (max-width: 1280px) {
  .history {
    padding-bottom: 30px;
    .year-content {
      overflow: hidden;
      height:880px;
    }
  }

  .history .wrap {
    padding-top: 15px;
  }
  .history #wrapper {
    margin-bottom: 15px;
  }
  .history .year-content {
    margin-top: -15px;
  }
  .history .year-content ul {
    max-width: 400px;
  }
  .history .year-content ul li h4 {
    font-size: 35px;
  }
}

/* jquery方法样式 */

@media (max-width: 768px) {
  .history {
    .wrap {
      padding: 10px 0;
      #wrapper {
        margin-bottom: 0;
        justify-content: flex-start;
      }
      .sidebar {
        width: 100%;
        .dd {
          margin-right: 20px;
          margin-bottom: 0;
          font-size: 18px;
        }
      }
    }
    .year-content {
      height: 830px;
      padding-bottom: 35px;
      ul li h4 {
        font-size: 30px;
      }
    }
  }
}
</style>
